export default "__VITE_ASSET__BS2vuAN6__"